<router-outlet>
    <app-spinner></app-spinner>
    <span *ngIf="showLoader" class="loading"></span>

</router-outlet>